<template>
  <button @click="click" class="info" :class="type" :aria-label="message">
    <i v-if="type === 'icon'" class="fas" :class="{ 'fa-microphone': !muted, 'fa-microphone-slash': muted }"></i>
    <p v-else>  <i class="fas" :class="{ 'fa-microphone': !muted, 'fa-microphone-slash': muted }"></i> {{ message }} </p>
  </button>
</template>

<script>
export default {
  name: "MuteButton",
  data() {
    return {
      muted: false,
    };
  },
  props: {
    type : {
      default : 'icon',
      required : false
    },
    state: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    click() {
      if (this.muted) {
        this.$emit('unmute');
      } else {
        this.$emit('mute');
      }
      this.muted = !this.muted;
    },
  },
  computed: {
    message() {
      return this.muted
        ? this.$t("call.turn-on-mic")
        : this.$t("call.turn-off-mic");
    },
  },
  watch: {
    state(newState) {
      this.muted = newState;
    },
  },
  created() {
    this.muted = this.state;
  },
};
</script>

<style>
</style>